import Keycloak from 'keycloak-js';

import config from './config';
import { isPublicRoute } from './services/auth';

const keycloak = new Keycloak(config.keycloakConfig);

export const initialize = () => {
  // Keycloak's session-status iframe is framed from the auth server, whose
  // `frame-ancestors` CSP lists only the deployed origins — never localhost.
  // Left on, the browser blocks the frame and init never resolves, so local dev
  // lands on the error screen. Deployed origins are in the allow-list and keep
  // the session check. Mirrors casa-dashboard-v2.
  const isLocalOrigin = ['localhost', '127.0.0.1'].includes(
    window.location.hostname
  );

  return keycloak.init({
    // Public routes must never force a login redirect.
    onLoad: isPublicRoute() ? 'check-sso' : 'login-required',
    checkLoginIframe: !isLocalOrigin,
  });
};

export const redirectToLogin = () => {
  keycloak.clearToken();
  keycloak.login();
};

export const logout = () => {
  return keycloak.logout();
};

export const getAccessToken = () => {
  return keycloak.token;
};

export const updateToken = (minValidity: number = 30) => {
  return keycloak.updateToken(minValidity);
};

export default keycloak;
